<template>
  <div class="mobile_mask_bg" v-if="iSmobileSearch" @click="handleCloseSearch"/>
</template>

<script>
export default {
    name:'DrawerBgMask',
    props: {
        iSmobileSearch: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        handleCloseSearch() {
            this.$emit('handleCloseSearch')
        }
    },
};
</script>

<style lang="scss" scoped>
    .mobile_mask_bg {
        background: #000;
        opacity: 0.3;
        width: 100%;
        top: 0;
        left: 0;
        height: 100%;
        position: fixed;
        z-index: 999;
    }
</style>